import { render, staticRenderFns } from "./ProjectCollectionForm.vue?vue&type=template&id=e16313ca&scoped=true"
import script from "./ProjectCollectionForm.vue?vue&type=script&lang=js"
export * from "./ProjectCollectionForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectCollectionForm.vue?vue&type=style&index=0&id=e16313ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16313ca",
  null
  
)

export default component.exports